import { render, staticRenderFns } from "./CreateRequirementCategory.vue?vue&type=template&id=52790e78"
import script from "./CreateRequirementCategory.vue?vue&type=script&lang=js"
export * from "./CreateRequirementCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports